import { ISortingDirection } from '@/types/ITableSorting';

export function sortArrayByProperty<T>(arr: T[], property: keyof T, order: ISortingDirection = 'asc'): T[] {
  return arr.sort((a, b) => {
    const valA = a[property];
    const valB = b[property];

    if (typeof valA === 'string' && typeof valB === 'string') {
      if (order === 'asc') {
        return valA.localeCompare(valB);
      } else {
        return valB.localeCompare(valA);
      }
    }

    if (typeof valA === 'number' && typeof valB === 'number') {
      if (order === 'asc') {
        return valA - valB;
      } else {
        return valB - valA;
      }
    }

    return 0;
  });
}
